<template>
    <div>
      <div class="content-block-title">
        <span>{{ activeProfile.kidName || 'Kid' }}’s</span>
        {{$lang.messages.profile.profile}}
      </div>
      <div class="row">
        <div class="col-xl-6">
          <div class="form-group">
            <label for="kidsname" class="form-label">{{$lang.messages.settings.kid_info.kid_name}}</label>
            <input
                id="kidsname"
                type="text"
                :value="activeProfile.kidName"
                ref="usernameInput"
                @blur="changeKidName($event.target.value)"
                :placeholder="$lang.messages.add_profile.enter_name" class="form-control">
            <div class="form-error" v-if="nameSymbolsLimitError">{{$lang.messages.add_profile.name_error_length}}</div>
            <div class="form-error" v-if="nameError">{{$lang.messages.add_profile.name_error}}</div>
          </div>
          <div class="form-group">
            <label class="form-label">{{$lang.messages.settings.kid_info.kid_age}}</label>
            <label class="radio-wrapper" :class="{active: activeProfile.kidAge === '5-8'}">
              <input name="kidsAge" type="radio"  class="radio-input" value="5-8"
                     :checked="activeProfile.kidAge === '5-8'"
                     @change="changeKidAge($event.target.value)">
              <span class="radio-check"></span>
              <span class="radio-label"><strong>5-8</strong>{{$lang.messages.years}}</span>
            </label>
            <label class="radio-wrapper" :class="{active: activeProfile.kidAge === '9-12'}">
              <input name="kidsAge" type="radio"  class="radio-input" value="9-12"
                     :checked="activeProfile.kidAge === '9-12'"
                     @change="changeKidAge($event.target.value)">
              <span class="radio-check"></span>
              <span class="radio-label"><strong>9-12</strong>{{$lang.messages.years}}</span>
            </label>
            <label class="radio-wrapper" :class="{active: activeProfile.kidAge === '13+'}">
              <input name="kidsAge" type="radio" class="radio-input" value="13+"
                     :checked="activeProfile.kidAge === '13+'"
                     @change="changeKidAge($event.target.value)">
              <span class="radio-check"></span>
              <span class="radio-label"><strong>13+</strong>{{ $lang.messages.years }}</span>
            </label>
          </div>
        </div>
      </div>
      <UploadAvatar :profile="activeProfile" @showchooseavatar="showChooseAvatar = true" />
      <div class="row">
        <div class="col-xl-6">
          <div class="form-group mb-3">
            <label for="kidsPassword" class="form-label">{{$lang.messages.settings.kid_info.kid_password}}</label>
            <input id="kidsPassword" type="text" :value="activeProfile.kidPassword || ''"
                   @input="changeKidPassword($event.target.value)"
                   :placeholder="$lang.messages.add_profile.enter_password" class="form-control">
          </div>
          <span @click="showRemoveProfile = true" class="profile-remove">{{$lang.messages.profile.remove_profile}}</span>
        </div>
      </div>

      <div v-if="showRemoveProfile" class="modal" @click.self="showRemoveProfile = false">
        <div class="modal-dialog modal-dialog-sm">
          <div v-if="profileId !== 'defaultProfileSettings' && !activeProfiles[profileId]">
            <div class="modal-title flex-center">Delete {{ activeProfile.kidName }} {{$lang.messages.profile.profile}}?</div>
            <div class="modal-content">
              <div class="avatar-holder m-auto">
                <img :src="activeProfile.avatar || $avatars[activeProfile.defaultAvatarId || 13]" width="110" height="150"
                     alt="avatar" class="mr-2">
              </div>
              <p class="text-center mt-1">{{$lang.messages.profile.all_data_will_delete}} <br> {{$lang.messages.profile.are_you_sure}}</p>
            </div>
            <div class="modal-footer text-center">
              <button class="btn btn-outline" @click="showRemoveProfile = false">{{ $lang.messages.cancel }}</button>
              <button class="btn btn-main ml-1" @click.stop="removeProfile">{{ $lang.messages.delete }}</button>
            </div>
          </div>
          <div v-else>
            <div class="modal-title flex-center" v-if="activeProfiles[profileId]">
              {{$lang.messages.profile.remove_active_profile_error}}
            </div>
            <div class="modal-title flex-center" v-else>
              {{$lang.messages.profile.cant_delete_profile}}
            </div>
            <div class="modal-footer text-center">
              <button class="btn btn-outline" @click="showRemoveProfile = false">
                {{ $lang.messages.ok }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal v-if="showChooseAvatar" @hidemodal="showChooseAvatar = false">
        <div slot="header">
          {{ $lang.messages.add_profile.change_avatar }}
        </div>
        <div slot="content">
          <ChooseAvatar
              @hidechooseavatar="showChooseAvatar = false"
              @changeavatar="changeAvatar"
              @changecustomavatar="changeCustomAvatar" />
        </div>
      </Modal>
    </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css'
import {mapState, mapGetters} from "vuex";
import saveSetting from '../components/mixins/saveSetting'
import {defaultProfileSettings} from "@/helpers/configs";
import UploadAvatar from "@/components/UploadAvatar";
import Modal from "@/components/common/Modal";
import ChooseAvatar from "@/components/ChooseAvatar";
export default {
  name: 'ProfileSettings',
  mixins: [saveSetting],
  props: ['profileId', 'profile'],
  data: function (){
    return {
      avatarLoading: false,
      avatarSrc: false,
      showRemoveProfile: false,
      avatarLimitError: false,
      nameSymbolsLimitError: false,
      nameError: false,
      showChooseAvatar: false,
      newProfileSettings: JSON.parse(JSON.stringify(defaultProfileSettings))
    }
  },
  components: {
    UploadAvatar, ChooseAvatar, Modal
  },
  computed: {
    ...mapGetters({
      profilesCount: 'profilesCount',
      activeProfiles: 'activeProfiles',
    }),
    ...mapState({
      user: state => state.user,
      isPremium: state => state.accountData.isPremium,
      activeProfile(){
        return !this.profile ? this.newProfileSettings : this.profile
      }
    })
  },
  methods: {
    changeCustomAvatar(src){
      this.saveProfileSettings(this.profileId,{'avatar': src, 'defaultAvatarId': null})
    },
    changeAvatar(id){
      this.saveProfileSettings(this.profileId,{'defaultAvatarId': id, 'avatar': null})
    },
    changeKidName(value){
      this.nameSymbolsLimitError = false
      this.nameError = false
      if (value.length <=15) {
        this.nameSymbolsLimitError = false;
        this.nameError = false;
        if(value.trim() !== '') {
          this.saveProfileSettings(this.profileId, {'kidName': value.trim()})
        } else {
          this.nameError = true;
        }
      } else  {
        this.$refs.usernameInput.value = this.activeProfile.kidName;
        this.nameSymbolsLimitError = true;
      }
    },
    changeKidAge(value){
      this.saveProfileSettings(this.profileId,{'kidAge': value})
    },
    changeKidPassword(value){
      this.saveProfileSettings(this.profileId,{'kidPassword': value})
    },
    removeProfile(){
      this.$emit('removeprofile', this.profileId)
      this.showRemoveProfile = false
    },
  }
}
</script>



